import _ from 'lodash'

const VISIBLE_EVENT_TYPE_NAMES = ['Motion', 'Magnet Open']

export default (lastEvents) =>
  _.filter(lastEvents, ({ eventType: { name } }) =>
    _.includes(VISIBLE_EVENT_TYPE_NAMES, name)
  )
